"use client";

import getQueryClient from "@/hooks/useQueryClientInstance";
import {
  isServer,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

let browserQueryClient: QueryClient | undefined = undefined;

function makeQueryClient() {
  if (isServer) {
    return getQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = getQueryClient();
    return browserQueryClient;
  }
}

const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(() => makeQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} position="bottom" />
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
